"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOfArrayEnsureInitialVal = exports.mapEnsureInitialVal = void 0;
function mapEnsureInitialVal(map, key, entry) {
    if (!map.has(key)) {
        map.set(key, entry);
    }
    return map.get(key);
}
exports.mapEnsureInitialVal = mapEnsureInitialVal;
function mapOfArrayEnsureInitialVal(map, key, entry) {
    var _a;
    if (!map.has(key)) {
        map.set(key, [entry]);
    }
    else {
        (_a = map.get(key)) === null || _a === void 0 ? void 0 : _a.push(entry);
    }
    return map.get(key);
}
exports.mapOfArrayEnsureInitialVal = mapOfArrayEnsureInitialVal;
